import route from '../urlex/route';

export default {
    install: function (Vue, options) {
        if (options && options.store){
            var store = options.store;
        }
        Vue.prototype.$api = {
            send(requestType, apiRoute, params = {}, data = null, config = {}) {
                return new Promise((resolve, reject) => {
                    Vue.prototype.$http[requestType](route('api.' + apiRoute, params ? params : []), data, config)
                        .then(res => {
                            resolve(res.data)
                        })
                        .catch(err => {
                            if(err.response && err.response.status === 401 && store){
                                store.commit('lockScreen');
                            }
                            reject(err);
                        })
                })
            },
            get(apiRoute, params = null) {
                return this.send('get', apiRoute, params);
            },
            post(apiRoute, data = null, params = null, headers = {}) {
                return this.send('post', apiRoute, params, data, headers);
            },
            put(apiRoute, data = null, params = null, headers = {}) {
                return this.send('put', apiRoute, params, data, headers);
            },
            patch(apiRoute, data = null, params = null) {
                return this.send('patch', apiRoute, params, data);
            },
            delete(apiRoute, params = null) {
                return this.send('delete', apiRoute, params);
            },
            download(apiRoute, params = null) {
                return this.send('get', apiRoute, params, {responseType: 'blob'});
            }
        };
    }
};
